import { DrugItem, FetchAttr, Filter, SortBy, SortDirection } from '../types';
import { postData } from '../utils';

export type PostDrugRequest = {
  textSearch?: string;
  pageSize: number;
  pageNumber: number;
  filters?: Filter[];
  sortBy?: SortBy;
  sortDirection?: SortDirection;
};

export type PostDrugResponse = {
  drugs: DrugItem[];
  filters: Filter[];
  totalCount: number;
};

export const defaultPageSize = 16;

const postDrugSearch = async (
  requestObj: PostDrugRequest,
  attr?: FetchAttr
): Promise<PostDrugResponse> => {
  const response = await postData(`drug/search`, requestObj, attr);
  return response;
};

export default postDrugSearch;
